function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 28C8.934 28 4 23.065 4 17 4 10.934 8.934 6 15 6s11 4.934 11 11c0 6.065-4.934 11-11 11zm0-26a1 1 0 010 2 1.001 1.001 0 010-2zm2.711 2.284A3.003 3.003 0 0015 0a3.003 3.003 0 00-2.711 4.284C6.417 5.534 2 10.761 2 17c0 7.168 5.832 13 13 13s13-5.832 13-13c0-6.239-4.417-11.466-10.289-12.716zm1.2 14.744l3.875 4.392a10.03 10.03 0 002.297-6.393c0-5.56-4.523-10.083-10.083-10.083v5.683a4.404 4.404 0 014.399 4.4c0 .72-.179 1.4-.488 2zm1.592 5.649l.78-.627-3.785-5.366c.258-.387.43-.838.485-1.332a3.004 3.004 0 00-2.657-3.308 3.003 3.003 0 00-3.308 2.657 3.003 3.003 0 002.657 3.308c.493.054.971-.018 1.405-.186l4.423 4.854zm-6.497-7.759a1 1 0 111.99.219 1 1 0 01-1.99-.219zm9.338-12.504L24.758 3 29 7.242l-1.414 1.415-4.242-4.243z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "2",
  y: "0",
  width: "27",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 28C8.934 28 4 23.065 4 17 4 10.934 8.934 6 15 6s11 4.934 11 11c0 6.065-4.934 11-11 11zm0-26a1 1 0 010 2 1.001 1.001 0 010-2zm2.711 2.284A3.003 3.003 0 0015 0a3.003 3.003 0 00-2.711 4.284C6.417 5.534 2 10.761 2 17c0 7.168 5.832 13 13 13s13-5.832 13-13c0-6.239-4.417-11.466-10.289-12.716zm1.2 14.744l3.875 4.392a10.03 10.03 0 002.297-6.393c0-5.56-4.523-10.083-10.083-10.083v5.683a4.404 4.404 0 014.399 4.4c0 .72-.179 1.4-.488 2zm1.592 5.649l.78-.627-3.785-5.366c.258-.387.43-.838.485-1.332a3.004 3.004 0 00-2.657-3.308 3.003 3.003 0 00-3.308 2.657 3.003 3.003 0 002.657 3.308c.493.054.971-.018 1.405-.186l4.423 4.854zm-6.497-7.759a1 1 0 111.99.219 1 1 0 01-1.99-.219zm9.338-12.504L24.758 3 29 7.242l-1.414 1.415-4.242-4.243z",
  fill: "currentColor"
}))));